/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetPositionExtendedDto } from './GetPositionExtendedDto';
import {
    GetPositionExtendedDtoFromJSON,
    GetPositionExtendedDtoFromJSONTyped,
    GetPositionExtendedDtoToJSON,
} from './GetPositionExtendedDto';

/**
 * 
 * @export
 * @interface GetPaeEstimateItemsDto
 */
export interface GetPaeEstimateItemsDto {
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    idx: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    estimateDate: string;
    /**
     * 
     * @type {GetPositionExtendedDto}
     * @memberof GetPaeEstimateItemsDto
     */
    position: GetPositionExtendedDto;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    paePositionSystemNumber: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetPaeEstimateItemsDto
     */
    purchaseFormDict: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetPaeEstimateItemsDto
     */
    countryDict?: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetPaeEstimateItemsDto
     */
    pathPhaseDict?: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    specialistTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    specialistTeamName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    deliveryTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    deliveryTeamName?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetPaeEstimateItemsDto
     */
    errors?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    actionGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    paePurchaseForm: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    purchaseAmount: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaeEstimateItemsDto
     */
    salesAmount: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetPaeEstimateItemsDto
     */
    ballDict?: GetDictionaryDto;
}

/**
 * Check if a given object implements the GetPaeEstimateItemsDto interface.
 */
export function instanceOfGetPaeEstimateItemsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idx" in value;
    isInstance = isInstance && "estimateDate" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "paePositionSystemNumber" in value;
    isInstance = isInstance && "purchaseFormDict" in value;
    isInstance = isInstance && "paePurchaseForm" in value;
    isInstance = isInstance && "purchaseAmount" in value;
    isInstance = isInstance && "salesAmount" in value;

    return isInstance;
}

export function GetPaeEstimateItemsDtoFromJSON(json: any): GetPaeEstimateItemsDto {
    return GetPaeEstimateItemsDtoFromJSONTyped(json, false);
}

export function GetPaeEstimateItemsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaeEstimateItemsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idx': json['idx'],
        'estimateDate': json['estimateDate'],
        'position': GetPositionExtendedDtoFromJSON(json['position']),
        'paePositionSystemNumber': json['paePositionSystemNumber'],
        'purchaseFormDict': GetDictionaryDtoFromJSON(json['purchaseFormDict']),
        'countryDict': !exists(json, 'countryDict') ? undefined : GetDictionaryDtoFromJSON(json['countryDict']),
        'pathPhaseDict': !exists(json, 'pathPhaseDict') ? undefined : GetDictionaryDtoFromJSON(json['pathPhaseDict']),
        'specialistTeamId': !exists(json, 'specialistTeamId') ? undefined : json['specialistTeamId'],
        'specialistTeamName': !exists(json, 'specialistTeamName') ? undefined : json['specialistTeamName'],
        'deliveryTeamId': !exists(json, 'deliveryTeamId') ? undefined : json['deliveryTeamId'],
        'deliveryTeamName': !exists(json, 'deliveryTeamName') ? undefined : json['deliveryTeamName'],
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
        'actionGroup': !exists(json, 'actionGroup') ? undefined : json['actionGroup'],
        'paePurchaseForm': json['paePurchaseForm'],
        'purchaseAmount': json['purchaseAmount'],
        'salesAmount': json['salesAmount'],
        'ballDict': !exists(json, 'ballDict') ? undefined : GetDictionaryDtoFromJSON(json['ballDict']),
    };
}

export function GetPaeEstimateItemsDtoToJSON(value?: GetPaeEstimateItemsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idx': value.idx,
        'estimateDate': value.estimateDate,
        'position': GetPositionExtendedDtoToJSON(value.position),
        'paePositionSystemNumber': value.paePositionSystemNumber,
        'purchaseFormDict': GetDictionaryDtoToJSON(value.purchaseFormDict),
        'countryDict': GetDictionaryDtoToJSON(value.countryDict),
        'pathPhaseDict': GetDictionaryDtoToJSON(value.pathPhaseDict),
        'specialistTeamId': value.specialistTeamId,
        'specialistTeamName': value.specialistTeamName,
        'deliveryTeamId': value.deliveryTeamId,
        'deliveryTeamName': value.deliveryTeamName,
        'errors': value.errors,
        'actionGroup': value.actionGroup,
        'paePurchaseForm': value.paePurchaseForm,
        'purchaseAmount': value.purchaseAmount,
        'salesAmount': value.salesAmount,
        'ballDict': GetDictionaryDtoToJSON(value.ballDict),
    };
}

